<p-menu #menu [model]="items" [popup]="true"></p-menu>
<button *ngIf="items.length" class="p-button-transparent" pButton type="button" (click)="menu.toggle($event)">
  <mat-icon
    class="helper-icon"
    matTooltip="Documentation"
    matTooltipPosition="left"
    aria-tooltip="Icon helper for documentation about the application"
    >help
  </mat-icon>
</button>
